module.exports = __webpack_public_path__ + "img/maneken_front_merures.8d9241e1.png";